import { authHeader, http } from "@/http-commons"

class FileDataService {

    download( params ){
        return http.get('api/v1/file/download', { params, headers : authHeader(), responseType: 'blob' })
    }
}

export default new FileDataService()